import styled, { css } from 'styled-components'
import Select from 'react-select'
import { Box, Button, Flex, Image, Input, Stack } from '@chakra-ui/react'

export const StatusPedidoContainer = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
`
export const LdsEllipsis = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  left: -18px;
  div {
    background: #fff;
    position: absolute;
    top: 15px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`
export const ContentModalInputGrama = styled(Input)`
  padding-right: 5px;
  letter-spacing: 1px;
  text-align: center;
  color: gray;
  border-color: ${(props) => (props.focusfalse ? '#FD7074' : '#414042')};
  animation: ${(props) => (props.focusfalse ? 'vibrate-1 5s linear 1s both' : 'none')};
  &:focus {
    border-color: ${(props) => (props.focusfalse ? '#FD7074' : '#414042')};
  }
  @keyframes vibrate-1 {
    0% {
      transform: translate(0);
    }
    20% {
      transform: translate(-2px, 2px);
    }
    40% {
      transform: translate(-2px, -2px);
    }
    60% {
      transform: translate(2px, 2px);
    }
    80% {
      transform: translate(2px, -2px);
    }
    100% {
      transform: translate(0);
    }
  }
`
export const ImageFecharModal = styled(Image)`
  cursor: pointer;
  margin-right: 15px;
  width: 40px;
  border-radius: 50%;
  animation: ${(props) => (props.sair ? 'slide-in-elliptic-top-fwd 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both, pulse 0.2s' : '')};
  &:active {
    animation: ${(props) =>
      props.sair
        ? 'slide-in-elliptic-top-fwd 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both, pulse 0.2s'
        : 'slide-in-elliptic-top-fwd 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both, pulse 0.2s'};
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 black;
      box-shadow: 0 0 0 0 black;
    }
    70% {
      -moz-box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
  @keyframes slide-in-elliptic-top-fwd {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.95);
    }
  }
`
export const StatusPedidoContainerText = styled.div`
  background-color: #414042;
  padding: 15px 0;
  font-family: Akrobat;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`
export const PedidoContainerModal = styled(Box)`
  width: 100%;
  height: 80vh;
  background-color: transparent;
  position: fixed;
  display: flex;
  // align-items: center;
  z-index: 99999;
  animation: slide-fwd-center 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @keyframes slide-fwd-center {
    0% {
      transform: translateZ(0);
    }
    100% {
      transform: translateZ(160px);
    }
  }
`
export const PedidoContainerModalFinalizar = styled.div`
  width: 100%;
  height: 80vh;
  background-color: transparent;
  position: fixed;
  display: flex;
  // align-items: center;
  z-index: 99;
  animation: slide-fwd-center 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @keyframes slide-fwd-center {
    0% {
      transform: translateZ(0);
    }
    100% {
      transform: translateZ(160px);
    }
  }
`
export const PedidoContainerModalContentFinalizar = styled.div`
  width: 1300px;
  height: 760px;
  border-radius: 0;
  box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
  margin: -100px auto 0 auto;
  background-color: #ffffff;
  position: relative;
`
export const PedidoContainerModalContent = styled.div`
  width: 100%;
  min-height: 100vh;
  border: 0.6px solid rgb(194, 194, 194);
  margin-top: 10px;
  background-color: #ffffff;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`
export const PedidoContainerModalContentFilter = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: #03a9f4;

  &--margin-top {
    top: 10px;
  }
  &--product {
    height: 80px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: #03a9f4;
  }
`
export const FilterButton = styled.button`
  border: none;
  padding: 0 13px;
  border-radius: 5px;
  height: 38px;
  margin-left: 10px;
  background-color: #414042;
  color: #fff;
`
export const FlexTextModalFinalizar = styled(Flex)`
  width: 100%;
  height: 50px;
  background-color: white;
  align-items: center;
  justify-content: space-between;
  margin: 30px auto 0 auto;
  p {
    text-align: center;
    font-weight: 400;
    font-family: 22px;
    color: white;
  }
`
export const FlexInputsTable = styled(Flex)`
  margin: 0 auto;
  width: 100%;
  height: 55px;
  align-items: center;
  justify-content: space-between;
  &:nth-child(even) {
    background-color: #f8f9f9;
  }
`
export const ButtonEnviarModalFinalizar = styled(Button)`
  text-align: center;
  border: none;
  background-color: #8ec505;
  width: 80px;
  height: 20px;
  margin-left: 15px;
  display: inline-flex;
  border-radius: 10px;
  font-size: 14px;
  position: relative;
  color: white;
  /* transition: 0.5s cubic-bezier(0.550, 0.055, 0.675, 0.190) both; */
  &::before {
    border-radius: 10px;
    border: #8ec505 solid 10px;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
    content: '';
  }

  &:active {
    /* animation: is-rippling 1.75s cubic-bezier(0.33, 1, 0.68, 1); */
    transform: translateY(2px);
    &::before {
      animation: none;
    }
  }

  @keyframes is-rippling {
    to {
      opacity: 0;
      transform: scale(1.05, 1.5);
    }
  }
`
export const FilterButtonWhite = styled.div`
  border: none;
  background-color: rgb(233, 231, 231);
  color: rgb(78, 78, 78);
  padding: 0 13px;
  height: 38px;
  margin-left: 10px;
  cursor: pointer;
  padding-top: 7px;
`
export const ModalContentGrid = styled.div`
  width: 95%;
  margin: 0 auto 0 auto;
  min-height: 100vh;
  position: relative;

  // overflow-x: scroll;
  // background-color: rgb(248, 248, 248);
  @media screen and (max-width: 1366px) {
    margin-top: -90px;
  }
`
export const ButtonEnviar = styled.button`
  box-shadow: none !important;
  color: black;
  width: 135px;
  font-size: 18px;
  position: relative;
  left: -80px;
  height: 50px;
  border: 1px solid black;
  border-radius: 3px;
  text-align: center;
  background-color: ${(props) => (props.loadingButton ? '#7fbc03' : 'white')};
  transition: all ease 0.3s;
  text-decoration: none;
  cursor: pointer;
  letter-spacing: 1px;
  animation: has-shown 1.5s cubic-bezier(0.785, 0.135, 0.15, 0.86) forwards;

  span {
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: all ease 0.5s;
    &:after {
      content: url('/images/seta-branca.png');
      position: absolute;
      opacity: 0;
      top: 3px;
      right: -20px;
      transition: 0.3s;
    }
  }
  &:active {
    background: #7fbc03;
  }
  &:hover,
  &:focus {
    height: 50px;
    border: 1px solid white;
    background: #7fbc03;
    transition: all ease 0.2s;
    color: white;
  }
  &:hover span {
    padding-right: 45px;
    &:after {
      opacity: 1;
      right: 0px;
    }
  }
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
`
export const ButtonSalvar = styled.button`
  width: 140px;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  border-radius: 10px;
  transition: ease-out 0.2s;
  font-family: 2rem;
  height: 40px;
  outline: none;
  font-weight: 600;
  border: 1px solid #7fbc03;
  background-color: ${(props) => (props.loadingButton ? '#7fbc03' : 'transparent')};
  &:active {
    transform: translateY(2px);
  }
  &:hover,
  &:focus {
    border-radius: 10px;
    color: white;
    border: 1px solid #7fbc03;
  }
  &:focus {
    background-color: ${(props) => (props.loadingButton ? '#7fbc03' : 'transparent')};
  }
  &::before {
    transition: 0.5s all ease;
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    opacity: 0;
    content: '';
    background-color: #7fbc03;
  }
  &:hover::before,
  &:focus::before {
    border-radius: 8px;
    transition: 0.5s all ease;
    left: 0;
    right: 0;
    opacity: 1;
    z-index: -1;
  }
`
export const StackForm = styled(Stack)`
  height: 300px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 6px;
    padding-top: 10px;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
`
export const ModalContentGridLoading = styled.div`
  width: 1000px;
  height: 600px;
  margin: 0 auto;
  position: absolute;
  background-color: #ffffff;
  align-items: center;
  z-index: 99999;
`
export const ModalContentGridLoadingContent = styled.div`
  display: ${(props) => (props.loading ? 'block' : 'none')};
  width: 100px;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`
export const ModalContentGridContentGridColumnFinalizar = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: #919aae;
  font-weight: 300;
  position: relative;
  &--border {
    width: 100px;
    border: 1px #03a9f4 solid;
    border-radius: 5px;
    width: 110px;
    margin-right: 5px;
  }

  thead {
    width: 700px;
    border-bottom: 2px solid #03a9f4;
    tr {
      th {
        width: 160px;
        color: #03a9f4;
        font-family: 'Akrobat ExtraBold';
        font-size: 15px;

        &.checkbox-size {
          width: 40px;
          min-width: 40px;
          max-width: 40px;
        }
        &.title-rotate {
          transform: rotate(-90deg);
          min-width: 40px;
          max-width: 40px;
        }
      }
    }
  }

  tbody {
    width: 700px;
    tr {
      margin: 10px 0;

      &:nth-child(even) {
        background-color: #fcfdfc;
      }

      td {
        width: 160px;
        text-transform: uppercase;
        text-align: center;
        font-family: 'Akrobat';
        font-size: 15px;
        padding: 0 10px;
        height: 50px;
        input {
          width: 100px;
          border: none;
          font-family: 'Akrobat';
          text-align: center;
        }
        &.checkbox-size {
          width: 40px;
          position: relative;
          top: -10px;
          min-width: 40px;
          max-width: 40px;
        }

        &.cub {
          display: flex;
          align-items: center;

          text-transform: inherit;

          a {
            text-decoration: none;
            display: flex;
            color: #03a9f4;
          }

          .icon {
            margin-right: 5px;
          }
        }

        &.btn {
          padding: 0;
        }
      }
    }
  }
`
export const ModalContentGridContentGridColumn = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: #919aae;
  font-weight: 300;
  position: relative;
  &--border {
    width: 100px;
    border: 1px #03a9f4 solid;
    border-radius: 5px;
    width: 110px;
    margin-right: 5px;
  }

  thead {
    width: 700px;
    border-bottom: 2px solid #03a9f4;
    tr {
      th {
        width: 160px;
        color: #03a9f4;
        font-family: 'Akrobat ExtraBold';
        font-size: 15px;

        &.checkbox-size {
          width: 40px;
          min-width: 40px;
          max-width: 40px;
        }
        &.title-rotate {
          transform: rotate(-90deg);
          min-width: 40px;
          max-width: 40px;
        }
      }
    }
  }

  tbody {
    width: 700px;
    tr {
      margin: 10px 0;

      &:nth-child(even) {
        background-color: #fcfdfc;
      }

      td {
        width: 160px;
        text-transform: uppercase;
        text-align: center;
        font-family: 'Akrobat';
        font-size: 15px;
        padding: 0 10px;
        height: 50px;
        input {
          width: 85px;
          border: none;
          font-family: 'Akrobat';
        }
        &.checkbox-size {
          width: 40px;
          position: relative;
          top: -10px;
          min-width: 40px;
          max-width: 40px;
        }

        &.cub {
          display: flex;
          align-items: center;

          text-transform: inherit;

          a {
            text-decoration: none;
            display: flex;
            color: #03a9f4;
          }

          .icon {
            margin-right: 5px;
          }
        }

        &.btn {
          padding: 0;
        }
      }
    }
  }
`
export const ModalContentOpenFilter = styled(Box)`
  width: 100%;
  height: 30px;
  position: absolute;
  float: left;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
`
export const ModalContentOpenFilterContent = styled.div`
  width: 96%;
  max-width: 1842px;
  height: 100%;
  margin-top: -1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent;
`
export const ModalContentOpenFilterContentControl = styled.div`
  width: 120px;
  height: 100%;
  position: relative;
  float: right;
  font-family: Akrobat;
  font-weight: bold;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  /* z-index: 999; */
  h1 {
    color: #414042;
    font-size: 18px;
  }

  span {
    margin-top: 0.3rem;
    color: #414042;
  }
`
export const ContentFilter = styled(Box)`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin: 20px 0;
  /* z-index: 99; */
  color: #414042;
`
export const ContentFilterTwo = styled(ContentFilter)`
  /* z-index: 99; */
`
export const ContentFilterThree = styled(ContentFilter)`
  /* z-index: 99; */
`
export const ContentFilterSelector = styled(Box)`
  background-color: #fff;
  -webkit-border-radius: 3px;
  font-family: Akrobat;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 5px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  z-index: ${(props) => (props.zIndex ? props.zIndex : 0)};
`
export const SelectorLabel = styled(Select)`
  font-weight: bold;
  font-family: Akrobat;
  width: 200px;
`
export const SelectorLabelPadrao = styled(SelectorLabel)`
  width: 290px;
`
export const SelectorLabelData = styled.div`
  width: 110px;
  font-family: Akrobat;
`
export const SelectorLabelStatus = styled(SelectorLabel)`
  width: 240px;
`
export const Legend = styled.div`
  width: 900px;
  height: 25px;
  font-family: Akrobat;
  position: relative;
  display: flex;
  justify-content: space-around;
  /* z-index: 99; */

  &__color:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
    z-index: 99;
  }
`
export const LegendTwo = styled(Legend)`
  width: 800px;
  z-index: 99;
`
export const LegendColor = styled.div`
  background-color: ${(props) => `${props.backgroundColor}`};
  width: 25px;
  height: 25px;
  position: relative;
  border-radius: 15px;
  .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 115%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }
  .tooltiptext::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #555 transparent;
    cursor: pointer;
  }
`
export const ResumeContentTables = styled(Box)`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`

export const ResumeContentTablesColumn = styled.div`
  width: 96%;
  // max-width: 1836px;
  min-height: 450px;
  max-height: 75vh;
  overflow-x: scroll;
  overflow-y: scroll;
  margin-left: auto;
  margin-right: auto;
`
export const ResumeContentTablesColumnTitle = styled.h5`
  width: 96%;
  max-width: 1842px;
  position: absolute;
  font-family: Akrobat;
  margin-left: auto;
  margin-right: auto;
  z-index: 3;
  height: 50px;
  color: #fff;
  font-size: 22px;
  background-color: #414042;
  font-weight: 400;
  padding: 5px 0;
  letter-spacing: 0.06rem;
  text-align: center;
  -webkit-border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-topright: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .white-space {
    visibility: hidden;
  }
`
export const ResumeContentTablesColumnLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  align-items: center;
  z-index: 1;
`
export const ResumeContentTablesColumnLoadingContent = styled.div`
  width: 100px;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`

export const ResumeContentTable = styled.table`
  min-width: 3526px;
  margin-left: auto;
  margin-right: auto;
  font-family: Akrobat;
  background-color: #fff;
  // border-collapse: separate;
  // position: sticky;
  // table-layout: auto;

  .grey {
    background-color: #d0d0d0;
    color: rgb(65, 64, 66);
  }
  .red {
    background-color: #e90006;
    color: white;
  }

  .pink {
    background-color: #e9006f;
    color: white;
  }

  .green {
    background-color: #00a653;
    color: white;
  }

  .blue {
    background-color: #1a97bf;
    color: white;
  }

  .dark-blue {
    background-color: #141299;
    color: white;
  }

  .orange {
    background-color: #e78d00;
    color: white;
  }

  .purple {
    background-color: #770b60;
    color: white;
  }

  .lilac {
    background-color: #b62aff;
    color: white;
  }

  .turquoise {
    background-color: #22d4c9;
    color: white;
  }

  .yellow-dark {
    background-color: #c0b900;
    color: white;
  }

  .brown {
    background-color: #795548;
    color: white;
  }

  .black {
    background-color: black;
    color: white;
  }
  thead {
    position: relative;
    top: 35px;
    th {
      // min-width: 120px;
      height: 50px;
      color: #414042;
      font-weight: 500;
      text-transform: uppercase;
      text-align: center;
      border-bottom: 1px #edf0f0 solid;
      line-height: 25px;
      font-size: 14px;
      font-family: 'Akrobat ExtraBold';
      letter-spacing: 0.03rem;
      line-height: 120%;
      padding: 8px 18px;
      position: -webkit-sticky;
      position: sticky;
      top: 35;
      z-index: 2;

      &:nth-child(1) {
        width: 114px;
        // height: 40px;
      }
      &:nth-child(2) {
        width: 104px;
        // height: 40px;
      }
      &:nth-child(3) {
        width: 52px;
        // height: 40px;
      }
      &:nth-child(4) {
        width: 155px;
        // height: 40px;
      }
      &:nth-child(5) {
        width: 95px;
        // height: 40px;
      }
      &:nth-child(6) {
        width: 156px;
        // height: 40px;
      }
      &:nth-child(7) {
        width: 77px;
        // height: 40px;
      }
      &:nth-child(8) {
        width: 154px;
        // height: 40px;
      }
      &:nth-child(9) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(10) {
        width: 178px;
        // height: 40px;
      }
      &:nth-child(11) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(12) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(13) {
        width: 188px;
        // height: 40px;
      }
      &:nth-child(14) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(15) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(16) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(17) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(18) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(19) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(20) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(21) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(22) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(23) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(26) {
        width: 158px;
        // height: 40px;
      }
      &:nth-child(28) {
        width: 158px;
        // height: 40px;
      }
    }
  }

  tbody {
    position: relative;
    top: 35px;
    width: 2926px;
    max-width: 420px;
    min-height: 300px;
    tr {
      &:nth-child(even) {
        background-color: #fcfdfc;
      }

      td {
        // min-width: 120px;

        font-size: 13px;
        font-family: 'Akrobat';
        letter-spacing: 0.03rem;
        padding: 8px 18px;
        border-left: 1px solid white;
        border-right: 1px solid white;
        border-top: 1px solid white;
        border-bottom: 1px solid white;

        &:nth-child(1) {
          width: 114px;
          // height: 40px;
        }
        &:nth-child(2) {
          width: 104px;
          // height: 40px;
        }
        &:nth-child(3) {
          width: 52px;
          // height: 40px;
        }
        &:nth-child(4) {
          width: 155px;
          // height: 40px;
        }
        &:nth-child(5) {
          width: 95px;
          // height: 40px;
        }
        &:nth-child(6) {
          width: 156px;
          // height: 40px;
        }
        &:nth-child(7) {
          width: 77px;
          // height: 40px;
        }
        &:nth-child(8) {
          width: 154px;
          // height: 40px;
        }
        &:nth-child(9) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(10) {
          width: 178px;
          // height: 40px;
        }
        &:nth-child(11) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(12) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(13) {
          width: 188px;
          // height: 40px;
        }
        &:nth-child(14) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(15) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(16) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(17) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(18) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(19) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(20) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(21) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(22) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(23) {
          width: 128px;
          // height: 40px;
        }
        &:nth-child(26) {
          width: 158px;
          // height: 40px;
        }
        &:nth-child(28) {
          width: 158px;
          // height: 40px;
        }

        input {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        input[type='radio']:after {
          width: 20px;
          height: 20px;
          border-radius: 15px;
          top: -2px;
          left: -1px;
          position: relative;
          background-color: #d1d3d1;
          content: '';
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
          cursor: pointer;
        }

        input[type='radio']:checked:after {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 15px;
          top: -2px;
          left: -1px;
          position: relative;
          background-color: #414042;
          content: '';
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }
      }
      form {
        td {
          // min-width: 120px;

          font-size: 13px;
          font-family: 'Akrobat';
          letter-spacing: 0.03rem;
          padding: 8px 18px;
          border-left: 1px solid white;
          border-right: 1px solid white;
          border-top: 1px solid white;
          border-bottom: 1px solid white;

          &:nth-child(1) {
            width: 114px;
            // height: 40px;
          }
          &:nth-child(2) {
            width: 104px;
            // height: 40px;
          }
          &:nth-child(3) {
            width: 52px;
            // height: 40px;
          }
          &:nth-child(4) {
            width: 155px;
            // height: 40px;
          }
          &:nth-child(5) {
            width: 95px;
            // height: 40px;
          }
          &:nth-child(6) {
            width: 156px;
            // height: 40px;
          }
          &:nth-child(7) {
            width: 77px;
            // height: 40px;
          }
          &:nth-child(8) {
            width: 154px;
            // height: 40px;
          }
          &:nth-child(9) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(10) {
            width: 178px;
            // height: 40px;
          }
          &:nth-child(11) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(12) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(13) {
            width: 188px;
            // height: 40px;
          }
          &:nth-child(14) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(15) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(16) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(17) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(18) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(19) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(20) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(21) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(22) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(23) {
            width: 128px;
            // height: 40px;
          }
          &:nth-child(26) {
            width: 158px;
            // height: 40px;
          }
          &:nth-child(28) {
            width: 158px;
            // height: 40px;
          }

          input {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }

          input[type='radio']:after {
            width: 20px;
            height: 20px;
            border-radius: 15px;
            top: -2px;
            left: -1px;
            position: relative;
            background-color: #d1d3d1;
            content: '';
            display: inline-block;
            visibility: visible;
            border: 2px solid white;
            cursor: pointer;
          }

          input[type='radio']:checked:after {
            cursor: pointer;
            width: 20px;
            height: 20px;
            border-radius: 15px;
            top: -2px;
            left: -1px;
            position: relative;
            background-color: #414042;
            content: '';
            display: inline-block;
            visibility: visible;
            border: 2px solid white;
          }
        }
      }
    }
  }
`
export const ResumeContentTablesOrder = styled(ResumeContentTable)`
  margin-left: auto;
  margin-right: auto;
  thead {
    position: relative;
    top: 30px;
    th {
      text-transform: capitalize !important;
      position: -webkit-sticky;
      position: sticky;
      background: linear-gradient(to bottom, rgb(194, 194, 194), white);
      top: 35px;
      z-index: 2;
      &:nth-child(1) {
        width: 114px;
        // height: 40px;
      }
      &:nth-child(2) {
        width: 104px;
        // height: 40px;
      }
      &:nth-child(3) {
        width: 52px;
        // height: 40px;
      }
      &:nth-child(4) {
        width: 155px;
        // height: 40px;
      }
      &:nth-child(5) {
        width: 95px;
        // height: 40px;
      }
      &:nth-child(6) {
        width: 156px;
        // height: 40px;
      }
      &:nth-child(7) {
        width: 77px;
        // height: 40px;
      }
      &:nth-child(8) {
        width: 154px;
        // height: 40px;
      }
      &:nth-child(9) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(10) {
        width: 178px;
        // height: 40px;
      }
      &:nth-child(11) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(12) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(13) {
        width: 188px;
        // height: 40px;
      }
      &:nth-child(14) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(15) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(16) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(17) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(18) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(19) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(20) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(21) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(22) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(23) {
        width: 128px;
        // height: 40px;
      }
      &:nth-child(26) {
        width: 158px;
        // height: 40px;
      }
      &:nth-child(28) {
        width: 158px;
        // height: 40px;
      }
    }
  }

  tbody {
    tr {
    }
  }
`

export const Tr = styled.tr`
  td {
    ${(props) =>
      props.honda &&
      css`
        border-bottom: 2px solid #ffd700 !important;
        border-top: 2px solid #ffd700 !important;
        position: relative;
        &::before {
          content: '★';
          color: #ffd700;
          font-size: 20px;
          position: absolute;
          top: 0;
          left: 5px;
        }
      `}

    &--grey {
      background-color: #d0d0d0;
      color: rgb(65, 64, 66);
    }
    &--red {
      background-color: #e90006;
      color: white;
    }

    &--green {
      background-color: #00a653;
      color: white;
    }

    &--blue {
      background-color: #1a97bf;
      color: white;
    }

    &--dark-blue {
      background-color: #141299;
      color: white;
    }

    &--orange {
      background-color: #e78d00;
      color: white;
    }

    &--purple {
      background-color: #770b60;
      color: white;
    }

    &--lilac {
      background-color: #b62aff;
      color: white;
    }

    &--turquoise {
      background-color: #22d4c9;
      color: white;
    }

    &--yellow-dark {
      background-color: #c0b900;
      color: white;
    }

    &--brown {
      background-color: #795548;
      color: white;
    }

    &--black {
      background-color: black;
      color: white;
    }
    text-align: center;

    span {
      width: 52%;

      cursor: pointer;
      margin-top: 5px;
      margin-bottom: 5px;
      border-radius: 3px;
      transition: 0.3s;

      p {
        min-width: 60px;
        height: 20px;
        position: absolute;
        margin-top: 3px;
        margin-left: 35px;
        font-size: 14px;
        font-family: 'Akrobat';
        color: white;
        border-radius: 3px;
        display: none;
        border-left: 8px solid #555;
        border-right: 8px solid #555;
        background-color: #555;
        z-index: 9;
      }
    }

    span:hover {
      p {
        display: block;
      }
    }

    &:nth-child(1) {
      width: 114px;
      font-size: 16px;
    }
    &:nth-child(2) {
      width: 104px;
      // height: 40px;
    }
    &:nth-child(3) {
      width: 52px;
      // height: 40px;
    }
    &:nth-child(4) {
      width: 155px;
      // height: 40px;
    }
    &:nth-child(5) {
      width: 95px;
      // height: 40px;
    }
    &:nth-child(6) {
      width: 156px;
      // height: 40px;
    }
    &:nth-child(7) {
      width: 77px;
      // height: 40px;
    }
    &:nth-child(8) {
      width: 154px;
      // height: 40px;
    }
    &:nth-child(9) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(10) {
      width: 178px;
      // height: 40px;
    }
    &:nth-child(11) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(12) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(13) {
      width: 188px;
      // height: 40px;
    }
    &:nth-child(14) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(15) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(16) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(17) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(18) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(19) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(20) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(21) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(22) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(23) {
      width: 128px;
      // height: 40px;
    }
    &:nth-child(26) {
      width: 158px;
      // height: 40px;
    }
    &:nth-child(28) {
      width: 158px;
      // height: 40px;
    }
  }
`
